"use client";

import { useLocale } from "next-intl";
import { useCallback } from "react";

export default function useLocaleLegacy(
  locales: Record<string, string> & { default: string }
) {
  const language = useLocale()

  const t = useCallback(
    (key: string) => {
      const fallbackText = `${key} not found in ${language}`;
      if (language && locales[language]) {
        return String(locales[language][key]) || fallbackText;
      }
      return String(locales[locales.default][key]) || fallbackText;
    },
    [language]
  );

  return {
    t,
  };
}
